import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as Close } from '../../../assets/images/svg/close.svg';
import Modal, { ModalClose } from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import SfhPrimaryButton from '../SellWizard/SfhPrimaryButton';
import SfhSecondaryButton from '../SellWizard/SfhSecondaryButton';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';

const ModalBodyWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(14)};
  padding-top: ${pxToRem(12)};
  padding-right: ${pxToRem(8)};
`;

const AbsoluteClose = styled(ModalClose)`
  position: absolute;
  top: 0;
  right: 0;

  &,
  svg {
    width: 20px;
    height: 20px;
  }

  svg > g {
    transform: scale(1.25);
    transform-origin: center;
  }
`;

const OptionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
`;

const OptionLabel = styled.p`
  margin: 0;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};
`;

const FullWidthPrimaryButton = styled(SfhPrimaryButton)`
  && {
    width: 100%;
  }
`;

const FullWidthSecondaryButton = styled(SfhSecondaryButton)`
  && {
    width: 100%;
  }
`;

const SellOrStoreChoiceModal = ({
  isOpen,
  close,
  onSellFromHomeClick,
  onMailInClick,
  showMailInOption,
  sellFromHomeLockStyle,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      maxWidth="360px"
      borderRadius="10px"
      close={close}
      hideHeader
      verticalCenter
      isCenterModal
      disableBlur
    >
      <ModalBody>
        <ModalBodyWrap>
          <AbsoluteClose
            type="button"
            onClick={close}
            aria-label={t('common.close')}
            data-cy="button-sell-or-store-choice-close"
          >
            <Close width={20} height={20} />
          </AbsoluteClose>

          <OptionGroup>
            <OptionLabel>
              {t('portfolio.sellFromHome.choice.sellLabel')}
            </OptionLabel>
            <FullWidthPrimaryButton
              lockStyle={sellFromHomeLockStyle}
              onClick={onSellFromHomeClick}
              data-cy="button-choice-sell-from-home"
              label={t('portfolio.sellFromHome.choice.sellCta')}
            />
          </OptionGroup>

          {showMailInOption && (
            <OptionGroup>
              <OptionLabel>
                {t('portfolio.sellFromHome.choice.mailInLabel')}
              </OptionLabel>
              <FullWidthSecondaryButton
                onClick={onMailInClick}
                data-cy="button-choice-mail-in-storage"
              >
                {t('portfolio.sellFromHome.choice.mailInCta')}
              </FullWidthSecondaryButton>
            </OptionGroup>
          )}
        </ModalBodyWrap>
      </ModalBody>
    </Modal>
  );
};

SellOrStoreChoiceModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  onSellFromHomeClick: PropTypes.func,
  onMailInClick: PropTypes.func,
  showMailInOption: PropTypes.bool,
  sellFromHomeLockStyle: PropTypes.bool,
};

export default SellOrStoreChoiceModal;
